class ZPFormatHelper {
  setParams (component) {
    this.component = component;
  }

  /**
   * Get closest end period class
   * @param string oneClass
   * @param string twoClass
   * @returns {string}
   */
  getMaxWarningClass (oneClass, twoClass) {
    if (oneClass === 'contract-endthis' || twoClass === 'contract-endthis') {
      return 'contract-endthis'
    }
    if (oneClass === 'contract-endnext' || twoClass === 'contract-endnext') {
      return 'contract-endnext'
    }
    if (oneClass === 'contract-endsoon' || twoClass === 'contract-endsoon') {
      return 'contract-endsoon'
    }
    return ''
  }

  /**
   * Get warning class based on contract or license end period
   * @param object item
   * @returns {string|null}
   */
  getContractWarningClass (item) {
    let res = null;
    const curDatePeriod = this.component.$store.getters.getItemsFromConfigWithFilter('currentDatePeriod');
    if (item && item.to_date_period_id && curDatePeriod && curDatePeriod.id) {
      const periodDiff = this.component.BasicHelper.getDatePeriodDiff(curDatePeriod.id, item.to_date_period_id);
      if (periodDiff === 0) {
        res = 'contract-endthis';
      } else if (periodDiff === 1) {
        res = 'contract-endnext';
      } else if (periodDiff < 3) {
        res = 'contract-endsoon';
      }
    }
    return res;
  }

  /**
   * Get options for report names.
   * @param groupBateryWithVkp - if TRUE, same report don't split battery and vkp reports
   * @returns {{}}
   */
  getReportNameOptions (groupBateryWithVkp = false, includeEmptyOption = false) {
    const options = {};
    if (includeEmptyOption) {
      options.null = { code: '', text: '', reportSubcode: null };
    }
    if (this.component.$store) {
      const self = this;
      const items = this.component.$store.getters.getDataFromConfigWithFilter('report_configs', null);
      Object.values(items).forEach(item => {
        const elCode = item.code.substr(0, item.code.indexOf('_'));
        let materialGroupId = item.contract_material_group_id;
        if (groupBateryWithVkp && elCode === 'B') {
          materialGroupId = self.component.$store.getters.getParamFromConfigByFilter('material_groups', 'code', 'VKP', 'id');
        }
        options[elCode] = { code: elCode, text: self.component.BasicHelper.getTranslation(item.name), material_group_id: materialGroupId, reportSubcode: item.reportSubcode };
      });
    }
    return Object.values(options);
  }

  getDrnReportOptions (contract) {
    const options = [];
    if (contract) {
      let items = Object.values(this.component.$store.getters.getItemsFromConfigWithFilter('drnTemplates', 'material_group_id', contract.material_group_id));
      items = items.filter(el => el.date_period_id).sort(function (a, b) {
        return (a.date_period_id - b.date_period_id)
      });
      items.forEach(el => {
        if (contract.from_date_period_id <= el.date_period_id && (contract.to_date_period_id == null || contract.to_date_period_id >= el.date_period_id)) {
          options.push({ code: el.code, year: this.component.BasicHelper.datePeriodCodeToYear(el.date_period_id) })
        }
      });
      if (options.length == 0 && items.length > 0) {
        const el = items[items.length - 1];
        if (el.date_period_id < contract.from_date_period_id) {
          options.push({ code: el.code, year: this.component.BasicHelper.datePeriodCodeToYear(contract.from_date_period_id) });
        }
      }
    }
    return options;
  }

  getConfigValuePeriod (configKey, filterKey, filterValue, param, translate, period, paramTooltip = null) {
    const item = this.component.$store.getters.getDataFromConfigWithFilter(configKey, filterKey, filterValue);
    if (item) {
      if (item.periodicnames && period !== null) {
        const el = Object.values(item.periodicnames).find(el => el.from_date_period_id <= period && (el.to_date_period_id == null || el.to_date_period_id >= period));
        if (el) {
          return this.component.BasicHelper.getConfigValueText(el, (paramTooltip == null ? param : paramTooltip), translate, this.component.$i18n.locale, this.component.$i18n.fallbackLocale);
        }
      }
      return this.component.BasicHelper.getConfigValueText(item, param, translate, this.component.$i18n.locale, this.component.$i18n.fallbackLocale);
    }
    return '';
  }

  getCurrentDatePeriodId () {
    const curDatePeriod = this.component.$store.getters.getItemsFromConfigWithFilter('currentDatePeriod');
    if (curDatePeriod && curDatePeriod.id) {
      return curDatePeriod.id;
    }
    return null;
  }

  getClassificationGroupFilterOptions () {
    const options = this.component
      .$store
      .getters
      .getConfigOptions('customer_priority_classification_groups', this.component.$i18n.locale)
      .map(item => ({
        ...item,
        text: item.code
      }));
    options.unshift({ text: this.component.$t('general.filters.without'), code: 'NULL' });
    return options;
  }
}

export default new ZPFormatHelper()
